// src/components/UserDashboard.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import CarsNavbar from "./CarsNavbar";
import NewCar from "./NewCar";
import AllCars from "./AllCars";
import NewRealEstate from "./NewRealEstate";
import AllRealEstate from "./AllRealEstate";
import { useNavigate } from "react-router-dom";

const UserDashboard = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(undefined);
  const [activeTab, setActiveTab] = useState("cars");

  const [userCars, setUserCars] = useState([]);
  const [userRealEstate, setUserRealEstate] = useState([]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    if (!storedUser || !token) {
      setUser(null);
      return;
    }

    setUser(storedUser);
  }, []);

  useEffect(() => {
    if (user === null) navigate("/login");
  }, [user, navigate]);

  // Fetch Cars
  useEffect(() => {
    if (!user) return;

    axios
      .get("/api/AffordableCars/my-cars", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => setUserCars(res.data))
      .catch((err) => console.error("Failed to load cars:", err));
  }, [user]);

  // Fetch Real Estate
  useEffect(() => {
    if (!user) return;

    axios
      .get("/api/AffordableRealestates/my-realestates", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => setUserRealEstate(res.data))
      .catch((err) => console.error("Failed to load real estate:", err));
  }, [user]);

  if (user === undefined) return <div>Loading...</div>;

  return (
    <>
      <CarsNavbar />

      <h2 style={{ textAlign: "center", margin: "2rem 0" }}>
        Welcome to Your Dashboard, {user.name}
      </h2>

      {/* Tabs */}
      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <button
          onClick={() => setActiveTab("cars")}
          style={{
            padding: "0.7rem 1.5rem",
            marginRight: "1rem",
            background: activeTab === "cars" ? "#007bff" : "#ccc",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Cars
        </button>

        <button
          onClick={() => setActiveTab("realestate")}
          style={{
            padding: "0.7rem 1.5rem",
            background: activeTab === "realestate" ? "#007bff" : "#ccc",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Real Estate
        </button>
      </div>

      {/* Cars Tab */}
      {activeTab === "cars" && (
        <>
          <NewCar setUserCars={setUserCars} />
          <AllCars userCars={userCars} setUserCars={setUserCars} />
        </>
      )}

      {/* Real Estate Tab */}
      {activeTab === "realestate" && (
        <>
          <NewRealEstate setUserRealEstate={setUserRealEstate} />
          <AllRealEstate
            userRealEstate={userRealEstate}
            setUserRealEstate={setUserRealEstate}
          />
        </>
      )}
    </>
  );
};

export default UserDashboard;
